import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { addMessage } from "~/features/toasts/redux/actions";
import { LOGOUT_SUCCESS_KEY } from "~/features/auth/login/loginUtils";

export function useLogoutMessageHandler() {
  const dispatch = useDispatch();
  useEffect(() => {
    const loggedOut = window.sessionStorage.getItem(LOGOUT_SUCCESS_KEY);
    if (loggedOut === "true") {
      window.sessionStorage.setItem(LOGOUT_SUCCESS_KEY, "false");
      dispatch(addMessage("info", "login.logout.success", "translation"));
    }
  }, []);
}
